module.exports = __webpack_public_path__ + "img/arrow-down-z-a.e0eb14e8.svg";